import React from "react";

const ApolloContext = React.createContext({
  fcpClient: null,
  rdaClient: null,
  behgClient: null
});

export default ApolloContext;
